<template>
    <BaseModal name="confirmedIssueAndRevertModal" width="420" :clickToClose="false" :shiftY="0.5"
        @before-close="closeModal" @before-open="openModal" :adaptive="true" height="auto"
        classes="bg-transparent shadow-none">
        <div
            class="modal-base-content modal-content py-20 h-100 px-30 rounded-25 bg-white position-relative overflow-hidden">
            <BaseLoader v-if="localLoading"></BaseLoader>
            <div class="d-flex justify-content-end">
                <slot name="modal-header"></slot>
                <button type="button" class="btn-close" @click="$modal.hide('confirmedIssueAndRevertModal')"></button>
            </div>
            <div
                class="modal-content-dynamic flex-grow-1 d-flex flex-column h-100 align-items-center justify-content-center">
                <p class="fw-bold mb-15 text-center" v-if="typeAccept == 'issuance'">
                    {{ dataLang['reg_contract_modal_9'] }}
                </p>
                <p class="fw-bold mb-15 text-center" v-if="typeAccept == 'revert'">
                    {{ dataLang['reg_contract_modal_20'] }}
                </p>
                <p class="fw-bold mb-15 text-center" v-if="typeAccept == 'out'"
                    v-html="dataLang['reg_contract_modal_16']">
                </p>

                <p class="text-center fsc-14">
                    {{ dataLang['reg_contract_modal_10'] }}
                </p>
                <div class="d-flex gap-5 mb-30 wp-100">
                    <BaseDatePicker :disabled-date="notAfterToday" :disabled-time="notAfterToday" v-model="dateTime"
                        time-title-format="DD.MM.YYYY"
                        :minute-step="typeAccept == 'issuance' || typeAccept == 'revert' ? 15 : 1" :clearable="false"
                        type="datetime" class="fsc-11 wp-100 text-center idiots-class-for-input-date" lang="ru"
                        :format="`${userSetting.company__tempalte_date} HH:mm`">
                    </BaseDatePicker>
                </div>
                <p class="fw-bold mb-15 text-center" v-if="typeAccept == 'issuance'">
                    {{ dataLang['reg_contract_modal_13'] }}
                </p>
                <p class="fw-bold mb-15 text-center" v-if="typeAccept == 'revert'">
                    {{ dataLang['reg_contract_modal_21'] }}
                </p>
                <p class="mb-15 text-center" v-if="typeAccept == 'out'">
                    {{ dataLang['reg_contract_modal_19'] }}
                </p>
                <div class="wp-100" v-if="typeAccept == 'issuance'">
                    <div class="fsc-14 ">
                        - {{ dataLang['reg_contract_modal_14'] }}
                    </div>
                    <div class="fsc-14 ">
                        - {{ dataLang['reg_contract_modal_15'] }}
                    </div>
                </div>
                <div class="wp-100" v-if="typeAccept == 'revert'">
                    <div class="fsc-14 ">
                        - {{ dataLang['reg_contract_modal_22'] }}
                    </div>
                    <div class="fsc-14 ">
                        - {{ dataLang['reg_contract_modal_23'] }}
                    </div>
                </div>
                <div class="d-flex justify-content-end gap-30 mt-30 pb-10">
                    <div @click="$modal.hide('confirmedIssueAndRevertModal')"
                        v-if="typeAccept == 'issuance' || typeAccept == 'revert'"
                        class="btn btn-sm py-5 btn-opposite px-15 rounded-5 d-flex align-items-center justify-content-center text-uppercase">
                        {{ dataLang['register_academy_text_18'] }}
                    </div>
                    <div @click="saveDate" v-if="typeAccept == 'issuance' || typeAccept == 'revert'"
                        class="btn btn-sm py-5 btn-primary action-hover px-15 rounded-5 d-flex align-items-center justify-content-center text-uppercase">
                        СОХРАНИТЬ
                    </div>
                    <div @click="saveDate" v-if="typeAccept == 'out'"
                        class="btn btn-sm py-5 btn-primary action-hover px-15 rounded-5 d-flex align-items-center justify-content-center text-uppercase">
                        ПОДТВЕРЖДАЮ.ОБЪЕКТ ВЫДАН
                    </div>
                </div>
            </div>
        </div>
    </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import GeneralService from '@/api/GeneralService.js'
import EventBus from '@/event-bus'

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
    components: {
    },
    data() {
        return {
            localLoading: false,
            contractId: null,
            typeAccept: null,
            dateTime: null
        }
    },
    methods: {
        notAfterToday(date) {
            if (this.typeAccept == 'out') {
                return date > this.$time()
            }
            return false
        },
        openModal(openedParams) {
            this.contractId = openedParams.params.contracts__id
            this.typeAccept = openedParams.params.typeAccept
            if (openedParams.params.additionalDate) {


                this.dateTime = new Date(openedParams.params.additionalDate.slice(0, -3))

                console.log(openedParams.params.additionalDate, this.dateTime);
            }

        },
        closeModal() {
            this.dateTime = null
        },
        saveDate() {
            if (this.dateTime) {
                this.localLoading = true
                let date = this.$time(this.dateTime).format('YYYY-MM-DD HH:mm:ss')
                let resultSendObject = this.typeAccept == 'revert' ? { contracts__ends: date } : { contracts__starts: date }
                GeneralService.edit(`/contracts/${this.contractId}/confirm/${this.typeAccept}`, resultSendObject)
                    .then(async (data) => {
                        this.$toast.success(data.data.message)
                        this.$emit('update')
                        this.$modal.hide('confirmedIssueAndRevertModal')
                    })
                    .catch((e) => {
                        console.error(e)
                        if (e?.response?.data?.message) {
                            this.$emit('error', e.response.data.errors)
                            this.$toast.error(e?.response?.data?.message, { duration: 5000 })
                            this.$modal.hide('confirmedIssueAndRevertModal')
                        }
                    }).finally(() => {
                        this.localLoading = false
                    })
            } else {
                this.$toast.error('Заполните дату', { duration: 5000 })
            }
        },
    },
    mounted() { },
    created() { },
    beforeDestroy() { },

    computed: {
        ...mapState('translationModule', ['dataLang']),
        ...mapState('userSettingModule', ['userSetting'])
    }
}
</script>
